var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { alertErrorHandler, showError, showSuccess } from '@spike/notifications-action';
import axios from 'axios';
import { ORDERS_DELETE_ITEM_START_ACTION_TYPE, ORDERS_DELETE_ITEM_SUCCESS_ACTION_TYPE, ORDERS_DELETE_PET_FROM_ORDER_START_ACTION_TYPE, ORDERS_DELETE_PET_FROM_ORDER_SUCCESS_ACTION_TYPE, ORDERS_ERROR_ACTION_TYPE, ORDERS_GET_START_ACTION_TYPE, ORDERS_GET_STATUS_START_ACTION_TYPE, ORDERS_GET_STATUS_SUCCESS_ACTION_TYPE, ORDERS_GET_SUCCESS_ACTION_TYPE, ORDERS_MIGRATE_START_ACTION_TYPE, ORDERS_MIGRATE_SUCCESS_ACTION_TYPE, ORDERS_NOT_FOUND_ACTION_TYPE, ORDERS_RELOAD_START_ACTION_TYPE, ORDERS_RELOAD_SUCCESS_ACTION_TYPE, ORDERS_RESET_ACTION_TYPE, ORDERS_SAVE_ITEM_START_ACTION_TYPE, ORDERS_SAVE_ITEM_SUCCESS_ACTION_TYPE, ORDERS_SAVE_NOTES_START_ACTION_TYPE, ORDERS_SAVE_NOTES_SUCCESS_ACTION_TYPE, ORDERS_SAVE_REDEEM_START_ACTION_TYPE, ORDERS_SAVE_REDEEM_SUCCESS_ACTION_TYPE, ORDERS_SAVE_START_ACTION_TYPE, ORDERS_SAVE_SUCCESS_ACTION_TYPE, ORDERS_UNPROCESSABLE_ACTION_TYPE, ORDERS_VERIFY_OUTDATED_START_ACTION_TYPE, ORDERS_VERIFY_OUTDATED_SUCCESS_ACTION_TYPE } from './OrdersActionsTypes';
import { convertToNotesRequest, convertToOrder, convertToOrderItemRequest, convertToOrderRedeemsRequest, convertToOrderRequest } from './OrdersConverter';
var ordersUrl = '/orders';
var orderItemsUrl = '/order_items';
var orderStatusUrl = '/order_status';
var orderByAppointmentIdUrl = '/appointment_order/';
var orderByIdUrl = '/get_order/';
var verifyOutdatedUrl = '/verify_order';
var migrateUrl = '/migrate_booking/';
var deletePetFromOrderUrl = '/clean_order';
var HTTP_STATUS_404_NOT_FOUND = 404;
var HTTP_STATUS_422_UNPROCESSABLE = 422;
export var getOrderThunk = function (apiClientWrapper, orderId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var order, apiError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getStart());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getOrderById(apiClientWrapper, orderId)];
                case 2:
                    order = _a.sent();
                    dispatch(getSuccess(order));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_1 = _a.sent();
                    console.error({ apiError: apiError_1 });
                    if (!axios.isCancel(apiError_1)) {
                        dispatch(error());
                        alertErrorHandler(apiError_1, dispatch, 'Error getting order.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getOrderStatusThunk = function (apiClientWrapper, orderId) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestUuid, orderStatus, apiError_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestUuid = apiClientWrapper.uuid();
                    dispatch(getStatusStart(requestUuid));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getOrderStatusById(apiClientWrapper, orderId)];
                case 2:
                    orderStatus = _a.sent();
                    getState().orders.requestUuids.orderStatus === requestUuid && dispatch(getStatusSuccess(orderStatus));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_2 = _a.sent();
                    console.error({ apiError: apiError_2 });
                    if (!axios.isCancel(apiError_2)) {
                        dispatch(error());
                        alertErrorHandler(apiError_2, dispatch, 'Error getting order status.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var migrateBookingThunk = function (apiClientWrapper, bookingId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, order, apiError_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(migrateStart());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    url = "".concat(migrateUrl).concat(bookingId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, '', apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, getOrderById(apiClientWrapper, response.data.order.id)];
                case 3:
                    order = _a.sent();
                    dispatch(migrateSuccess(order));
                    return [3 /*break*/, 5];
                case 4:
                    apiError_3 = _a.sent();
                    console.error({ apiError: apiError_3 });
                    if (!axios.isCancel(apiError_3)) {
                        dispatch(error());
                        alertErrorHandler(apiError_3, dispatch, 'Error migrating order.');
                    }
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
export var reloadOrderThunk = function (apiClientWrapper) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var order, requestUuid, orderId, reloadedOrder, apiError_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    order = getState().orders.order;
                    if (!order) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    requestUuid = apiClientWrapper.uuid();
                    dispatch(reloadStart(requestUuid));
                    orderId = order.id;
                    return [4 /*yield*/, getOrderById(apiClientWrapper, orderId)];
                case 2:
                    reloadedOrder = _a.sent();
                    dispatch(reloadSuccess(reloadedOrder));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_4 = _a.sent();
                    console.error({ apiError: apiError_4 });
                    if (!axios.isCancel(apiError_4)) {
                        dispatch(error());
                        alertErrorHandler(apiError_4, dispatch, 'Error reloading order.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getOrderByAppointmentThunk = function (apiClientWrapper, appointmentId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var order, apiError_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getStart());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getOrderByAppointmentId(apiClientWrapper, appointmentId)];
                case 2:
                    order = _a.sent();
                    dispatch(getSuccess(order));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_5 = _a.sent();
                    console.error({ apiError: apiError_5 });
                    if (!axios.isCancel(apiError_5)) {
                        dispatch(error());
                        alertErrorHandler(apiError_5, dispatch, 'Error getting order.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
var getOrderByAppointmentId = function (apiClientWrapper, appointmentId) { return __awaiter(void 0, void 0, void 0, function () {
    var url, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(orderByAppointmentIdUrl).concat(appointmentId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, convertToOrder(response.data, apiClientWrapper.masterData, apiClientWrapper.marketplace, apiClientWrapper.timeZone)];
        }
    });
}); };
var getOrderById = function (apiClientWrapper, orderId) { return __awaiter(void 0, void 0, void 0, function () {
    var url, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(orderByIdUrl).concat(orderId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, convertToOrder(response.data, apiClientWrapper.masterData, apiClientWrapper.marketplace, apiClientWrapper.timeZone)];
        }
    });
}); };
var getOrderStatusById = function (apiClientWrapper, orderId) { return __awaiter(void 0, void 0, void 0, function () {
    var url, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(orderStatusUrl, "/").concat(orderId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, { orderId: orderId, paid: response.data.paid, invoiceId: response.data.invoice_id, invoiceBalance: response.data.invoice_balance }];
        }
    });
}); };
export var saveOrderThunk = function (apiClientWrapper, order) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, save, saveOrderBody, response, savedOrderId, order_1, apiError_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(saveStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(ordersUrl).concat(order.id ? "/".concat(order.id) : "", "?marketplace_id=").concat(marketplaceId);
                    save = order.id === undefined ? apiClientWrapper.apiClient.post : apiClientWrapper.apiClient.patch;
                    saveOrderBody = convertToOrderRequest(order, marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, save(url, saveOrderBody, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    savedOrderId = response.data.id;
                    return [4 /*yield*/, getOrderById(apiClientWrapper, savedOrderId)];
                case 3:
                    order_1 = _a.sent();
                    dispatch(saveSuccess(order_1));
                    dispatch(showSuccess('Order saved!'));
                    return [3 /*break*/, 5];
                case 4:
                    apiError_6 = _a.sent();
                    if (!axios.isCancel(apiError_6)) {
                        if (apiError_6.response &&
                            apiError_6.response.status === HTTP_STATUS_404_NOT_FOUND) {
                            dispatch(notFound());
                        }
                        else {
                            dispatch(error());
                            alertErrorHandler(apiError_6, dispatch, 'Error saving order.');
                        }
                    }
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
export var saveOrderRedeemsThunk = function (apiClientWrapper, orderId, orderItemRedeems) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, saveOrderRedeemBody, response, savedOrderId, order, apiError_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(saveRedeemStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(ordersUrl, "/").concat(orderId, "?marketplace_id=").concat(marketplaceId);
                    saveOrderRedeemBody = convertToOrderRedeemsRequest(orderId, orderItemRedeems, marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, saveOrderRedeemBody, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    savedOrderId = response.data.id;
                    return [4 /*yield*/, getOrderById(apiClientWrapper, savedOrderId)];
                case 3:
                    order = _a.sent();
                    dispatch(saveRedeemSuccess(order));
                    return [3 /*break*/, 5];
                case 4:
                    apiError_7 = _a.sent();
                    if (!axios.isCancel(apiError_7)) {
                        if (apiError_7.response &&
                            apiError_7.response.status === HTTP_STATUS_404_NOT_FOUND) {
                            dispatch(notFound());
                        }
                        else if (apiError_7.response &&
                            apiError_7.response.status === HTTP_STATUS_422_UNPROCESSABLE) {
                            dispatch(unprocessable());
                        }
                        else {
                            dispatch(error());
                            alertErrorHandler(apiError_7, dispatch, 'Error saving order redeems.');
                        }
                    }
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
export var saveNotesThunk = function (apiClientWrapper, orderId, notes) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, saveNotesBody, response, savedOrderId, savedNotes, apiError_8;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dispatch(saveNotesStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(ordersUrl).concat(orderId ? "/".concat(orderId) : "", "?marketplace_id=").concat(marketplaceId);
                    saveNotesBody = convertToNotesRequest(notes);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, saveNotesBody, apiClientWrapper.requestConfig)];
                case 2:
                    response = _b.sent();
                    savedOrderId = response.data.id;
                    savedNotes = (_a = response.data.notes) !== null && _a !== void 0 ? _a : '';
                    dispatch(saveNotesSuccess(savedNotes, savedOrderId));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_8 = _b.sent();
                    if (!axios.isCancel(apiError_8)) {
                        if (apiError_8.response &&
                            apiError_8.response.status === HTTP_STATUS_404_NOT_FOUND) {
                            dispatch(notFound());
                        }
                        else {
                            dispatch(error());
                            alertErrorHandler(apiError_8, dispatch, 'Error saving notes.');
                        }
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveOrderItemThunk = function (apiClientWrapper, orderItem) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, orderId, saveOrderItemBody, save, order, apiError_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(orderItem.orderId === undefined)) return [3 /*break*/, 1];
                    dispatch(error());
                    dispatch(showError('Error saving order item, undefined order id.'));
                    return [3 /*break*/, 6];
                case 1:
                    dispatch(saveItemStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(orderItemsUrl).concat(orderItem.id ? "/".concat(orderItem.id) : "", "?marketplace_id=").concat(marketplaceId);
                    orderId = orderItem.orderId;
                    saveOrderItemBody = convertToOrderItemRequest(orderItem, marketplaceId, orderId);
                    save = orderItem.id === undefined ? apiClientWrapper.apiClient.post : apiClientWrapper.apiClient.patch;
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 5, , 6]);
                    return [4 /*yield*/, save(url, saveOrderItemBody, apiClientWrapper.requestConfig)];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, getOrderById(apiClientWrapper, orderId)];
                case 4:
                    order = _a.sent();
                    dispatch(saveItemSuccess(order));
                    dispatch(showSuccess('Order Item saved!'));
                    return [3 /*break*/, 6];
                case 5:
                    apiError_9 = _a.sent();
                    if (!axios.isCancel(apiError_9)) {
                        if (apiError_9.response &&
                            apiError_9.response.status === HTTP_STATUS_404_NOT_FOUND) {
                            dispatch(notFound());
                        }
                        else {
                            dispatch(error());
                            alertErrorHandler(apiError_9, dispatch, 'Error saving order item.');
                        }
                    }
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
};
export var deleteOrderItemThunk = function (apiClientWrapper, orderId, orderItemId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, order, apiError_10;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(deleteItemStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(orderItemsUrl, "/").concat(orderItemId, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.delete(url, apiClientWrapper.requestConfig)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, getOrderById(apiClientWrapper, orderId)];
                case 3:
                    order = _a.sent();
                    dispatch(deleteItemSuccess(order));
                    dispatch(showSuccess('Order Item deleted!'));
                    return [3 /*break*/, 5];
                case 4:
                    apiError_10 = _a.sent();
                    if (!axios.isCancel(apiError_10)) {
                        if (apiError_10.response &&
                            apiError_10.response.status === HTTP_STATUS_404_NOT_FOUND) {
                            dispatch(notFound());
                        }
                        else {
                            dispatch(error());
                            alertErrorHandler(apiError_10, dispatch, 'Error deleting order item.');
                        }
                    }
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
export var deletePetFromOrderThunk = function (apiClientWrapper, orderId, petId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, order, apiError_11;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(deletePetFromOrderStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(deletePetFromOrderUrl, "/").concat(orderId, "?marketplace_id=").concat(marketplaceId, "&pet_id=").concat(petId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.delete(url, apiClientWrapper.requestConfig)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, getOrderById(apiClientWrapper, orderId)];
                case 3:
                    order = _a.sent();
                    dispatch(deletePetFromOrderSuccess(order));
                    dispatch(showSuccess('Pet deleted from Order!'));
                    return [3 /*break*/, 5];
                case 4:
                    apiError_11 = _a.sent();
                    if (!axios.isCancel(apiError_11)) {
                        if (apiError_11.response &&
                            apiError_11.response.status === HTTP_STATUS_404_NOT_FOUND) {
                            dispatch(notFound());
                        }
                        else {
                            dispatch(error());
                            alertErrorHandler(apiError_11, dispatch, 'Error deleting pet from order.');
                        }
                    }
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
export var verifyOutdatedThunk = function (apiClientWrapper, orderId, orderVersion, invoiceId, invoiceVersion) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var onlyOrder, url, response, apiError_12;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    dispatch(verifyOutdatedStart());
                    onlyOrder = invoiceId === undefined;
                    url = "".concat(verifyOutdatedUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId, "&order_id=").concat(orderId, "&order_version=").concat(orderVersion, "&invoice_id=").concat(invoiceId !== null && invoiceId !== void 0 ? invoiceId : '', "&invoice_version=").concat(invoiceVersion !== null && invoiceVersion !== void 0 ? invoiceVersion : '');
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _c.sent();
                    dispatch(verifyOutdatedSuccess(((_a = response.data.order_status) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) !== 'ok', onlyOrder ? undefined : ((_b = response.data.invoice_status) === null || _b === void 0 ? void 0 : _b.toLocaleLowerCase()) !== 'ok', onlyOrder ? undefined : response.data.invoice_full_paid));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_12 = _c.sent();
                    if (!axios.isCancel(apiError_12)) {
                        dispatch(error());
                        alertErrorHandler(apiError_12, dispatch, 'Error verifying outdated order.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var reset = function () {
    return {
        type: ORDERS_RESET_ACTION_TYPE,
    };
};
var getStart = function () {
    return {
        type: ORDERS_GET_START_ACTION_TYPE,
    };
};
export var getSuccess = function (order) {
    return {
        type: ORDERS_GET_SUCCESS_ACTION_TYPE,
        payload: {
            order: order,
        },
    };
};
var getStatusStart = function (requestUuid) {
    return {
        type: ORDERS_GET_STATUS_START_ACTION_TYPE,
        payload: {
            requestUuid: requestUuid
        }
    };
};
export var getStatusSuccess = function (orderStatus) {
    return {
        type: ORDERS_GET_STATUS_SUCCESS_ACTION_TYPE,
        payload: {
            orderStatus: orderStatus
        },
    };
};
var migrateStart = function () {
    return {
        type: ORDERS_MIGRATE_START_ACTION_TYPE,
    };
};
export var migrateSuccess = function (order) {
    return {
        type: ORDERS_MIGRATE_SUCCESS_ACTION_TYPE,
        payload: {
            order: order,
        },
    };
};
var reloadStart = function (requestUuid) {
    return {
        type: ORDERS_RELOAD_START_ACTION_TYPE,
        payload: {
            requestUuid: requestUuid
        }
    };
};
export var reloadSuccess = function (order) {
    return {
        type: ORDERS_RELOAD_SUCCESS_ACTION_TYPE,
        payload: {
            order: order
        },
    };
};
var saveStart = function () {
    return {
        type: ORDERS_SAVE_START_ACTION_TYPE,
    };
};
var saveSuccess = function (order) {
    return {
        type: ORDERS_SAVE_SUCCESS_ACTION_TYPE,
        payload: {
            order: order,
        },
    };
};
var saveRedeemStart = function () {
    return {
        type: ORDERS_SAVE_REDEEM_START_ACTION_TYPE,
    };
};
var saveRedeemSuccess = function (order) {
    return {
        type: ORDERS_SAVE_REDEEM_SUCCESS_ACTION_TYPE,
        payload: {
            order: order,
        },
    };
};
var saveNotesStart = function () {
    return {
        type: ORDERS_SAVE_NOTES_START_ACTION_TYPE,
    };
};
var saveNotesSuccess = function (notes, orderId) {
    return {
        type: ORDERS_SAVE_NOTES_SUCCESS_ACTION_TYPE,
        payload: {
            notes: notes,
            orderId: orderId
        },
    };
};
var saveItemStart = function () {
    return {
        type: ORDERS_SAVE_ITEM_START_ACTION_TYPE,
    };
};
var saveItemSuccess = function (order) {
    return {
        type: ORDERS_SAVE_ITEM_SUCCESS_ACTION_TYPE,
        payload: {
            order: order,
        },
    };
};
var deleteItemStart = function () {
    return {
        type: ORDERS_DELETE_ITEM_START_ACTION_TYPE,
    };
};
var deleteItemSuccess = function (order) {
    return {
        type: ORDERS_DELETE_ITEM_SUCCESS_ACTION_TYPE,
        payload: {
            order: order,
        },
    };
};
var deletePetFromOrderStart = function () {
    return {
        type: ORDERS_DELETE_PET_FROM_ORDER_START_ACTION_TYPE,
    };
};
var deletePetFromOrderSuccess = function (order) {
    return {
        type: ORDERS_DELETE_PET_FROM_ORDER_SUCCESS_ACTION_TYPE,
        payload: {
            order: order,
        },
    };
};
var verifyOutdatedStart = function () {
    return {
        type: ORDERS_VERIFY_OUTDATED_START_ACTION_TYPE,
    };
};
var verifyOutdatedSuccess = function (orderOudated, invoiceOutdated, invoiceFullPaid) {
    return {
        type: ORDERS_VERIFY_OUTDATED_SUCCESS_ACTION_TYPE,
        payload: {
            outdated: {
                order: orderOudated,
                invoice: invoiceOutdated,
                invoiceFullPaid: invoiceFullPaid,
            }
        },
    };
};
var error = function () {
    return {
        type: ORDERS_ERROR_ACTION_TYPE,
    };
};
var notFound = function () {
    return {
        type: ORDERS_NOT_FOUND_ACTION_TYPE,
    };
};
var unprocessable = function () {
    return {
        type: ORDERS_UNPROCESSABLE_ACTION_TYPE,
    };
};
